export const RDX_EXP_SAVE_SUBMIT = 'rdx/exp/save/submit';
export const RDX_EXP_SAVE_SUBMIT_DONE = 'rdx/exp/save/submit/done';
export const RDX_EXP_SAVE_SUBMIT_ERR = 'rdx/exp/save/submit/error';
export const RDX_EXP_DATA_UPDATE = 'rdx/exp/update/data';
export const RDX_EXP_DATA_UPDATE_DONE = 'rdx/exp/update/data/done';
export const RDX_EXP_DATA_UPDATE_ERR = 'rdx/exp/update/data/error';
export const RDX_EXP_UPLOAD_CERTIFICATE_DONE = 'rdx/exp/upload/certificate/done';
export const RDX_EXP_UPLOAD_CERTIFICATE_ERR = 'rdx/exp/upload/certificate/error';
export const RDX_EXP_QUESTIONNAIRE_FETCH = 'rdx/exp/questionnaire/fetch';
export const RDX_EXP_QUESTIONNAIRE_FETCH_DONE = 'rdx/exp/questionnaire/fetch/done';
export const RDX_EXP_QUESTIONNAIRE_FETCH_ERROR = 'rdx/exp/questionnaire/fetch/error';
export const RDX_EXP_RESULT_FETCH = 'rdx/exp/result/fetch';
export const RDX_EXP_RESULT_FETCH_DONE = 'rdx/exp/result/fetch/done';
export const RDX_EXP_RESULT_FETCH_ERROR = 'rdx/exp/result/fetch/error';
export const RDX_EXP_DOWNLOAD_FILE = 'rdx/exp/download/file';
export const RDX_EXP_DOWNLOAD_FILE_DONE = 'rdx/exp/download/file/done';
export const RDX_EXP_QUESTIONNAIRE_CLEAN_ERROR = 'rdx/exp/clean/error';

export const cleanError = (request, params) => {
  return {
    type: RDX_EXP_QUESTIONNAIRE_CLEAN_ERROR,
    data: request,
    params: params,
  };
};

export const getExpData = (request, params) => {
  return {
    type: RDX_EXP_QUESTIONNAIRE_FETCH,
    data: request,
    params: params,
  };
};

export const getExpDataDone = (data) => {
  return {
    type: RDX_EXP_QUESTIONNAIRE_FETCH_DONE,
    data: data,
  };
};

export const getExpDataErrorInfo = (errorInfo) => {
  return {
    type: RDX_EXP_QUESTIONNAIRE_FETCH_ERROR,
    errorInfo: errorInfo,
  };
};

export const getExpResult = (request, params) => {
  return {
    type: RDX_EXP_RESULT_FETCH,
    data: request,
    params: params,
  };
};

export const getExpResultDone = (data) => {
  return {
    type: RDX_EXP_RESULT_FETCH_DONE,
    data: data,
  };
};

export const getExpResultErrorInfo = (errorInfo) => {
  return {
    type: RDX_EXP_RESULT_FETCH_ERROR,
    errorInfo: errorInfo,
  };
};

export const updateExpData = (data) => {
  return {
    type: RDX_EXP_DATA_UPDATE,
    data: data,
  };
};

export const updateExpDataDone = (data) => {
  return {
    type: RDX_EXP_DATA_UPDATE_DONE,
    data: data,
  };
};

export const updateExpDataErr = (data, errorInfo) => {
  return {
    type: RDX_EXP_DATA_UPDATE_ERR,
    data: data,
    errorInfo: errorInfo,
  };
};

export const submitExpData = (data) => {
  return {
    type: RDX_EXP_SAVE_SUBMIT,
    data: data,
  };
};

export const submitExpDataDone = (data) => {
  return {
    type: RDX_EXP_SAVE_SUBMIT_DONE,
    data: data,
  };
};

export const submitDataErr = (data, errorInfo) => {
  return {
    type: RDX_EXP_SAVE_SUBMIT_ERR,
    data: data,
    errorInfo: errorInfo,
  };
};

export const uploadExpCertificateDone = (data) => {
  return {
    type: RDX_EXP_UPLOAD_CERTIFICATE_DONE,
    data: data,
  };
};

export const uploadExpCertificateErr = (data, errorInfo) => {
  return {
    type: RDX_EXP_UPLOAD_CERTIFICATE_ERR,
    data: data,
    errorInfo: errorInfo,
  };
};

export const downloadFile = (data) => {
  return {
    type: RDX_EXP_DOWNLOAD_FILE,
    data: data,
  };
};

export const downloadFileDone = (data) => {
  return {
    type: RDX_EXP_DOWNLOAD_FILE_DONE,
    data: data,
  };
};
